module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"parentDeal":"Original Deal","childDeal":"Copy Deal"},"fr":{"parentDeal":"Dossier source","childDeal":"Dossier copie"}}')
  delete Component.options._Ctor
}
